import vpcApiRequest from "./request";

import * as _ from "lodash";

import icmpTypes from "./_icmpTypes";
import Vue from "vue";

var obj: any = {
    "-1": "全部协议",
    8: "Echo",
    0: "Echo Reply",
    3: "Destination Unreachable",
    4: "Source Quench",
    5: "Redirect Message",
    9: "Router Advertisement",
    10: "Router Solicitation",
    11: "Time Exceeded",
    12: "Parameter Problem: Bad IP header",
    13: "Timestamp",
    14: "Timestamp Reply",
    15: "Information Request",
    16: "Information Reply",
    17: "Address Mask Reques",
    18: "Address Mask Reply",
    30: "Traceroute"
};

function icmpTypeToString(type: any) {
    if (type === undefined) return;
    return obj[type];
}

function getIcmpTypes() {
    let arr: any[] = [];
    _.forEach(obj, (title, code) => {
        arr.push({
            value: String(code),
            title: title
        });
    });
    arr.sort((a, b) => {
        return a - b;
    });
    return arr;
}

function icmpCodeToString(type: any, code: any) {
    if (type === undefined) return;
    if (type == "-1") {
        return Vue.$trans(`全部协议`);
    }
    var thisType = icmpTypes[type];
    var thisCode = "";
    _.forEach(thisType, item => {
        if (item.value == code) {
            thisCode = item.text;
            return;
        }
    });
    return thisCode;
}

var routeTypes = {
    Local: Vue.$trans(`本地子网`),
    InternetGateway: Vue.$trans(`互联网网关`),
    Peering: Vue.$trans(`对等连接`),
    Tunnel: Vue.$trans(`隧道网关`),
    Host: Vue.$trans(`主机路由`),
    DirectConnect: Vue.$trans(`专线路由`),
    Vpn: Vue.$trans(`VPN路由`),
    endpoint: Vue.$trans(`终端子网`),
    Reserve: Vue.$trans(`终端子网`),
    Cic: Vue.$trans(`云企业网`)
};

export default {
    routeTypes,
    icmpTypes,
    icmpTypeToString,
    icmpCodeToString,
    getIcmpTypes,
    //每次切换地址时就会请求一次获取一次所有VPC
    //过程：第一次进入页面,如果localStorage.vpcId不存在,那么localStorage.vpcId取vpcList的第一条数据
    //将currentVpc resole出去,为了在index.js获取currentVpc的1.0.0.0和/24分开
    //这时如果更换VPC,走changeVpc方法,将localStorage.vpcId改变,currentVpc里的id和name都变
    //这时切换地址有localStorage.vpcId了,重新请求所有VPC
    //如果有localStorage.vpcId,赋值给currentVpc.vpcId,通过localStorage.vpcId筛选vpcName
    //再将currentVpc resole出去,为了在index.js获取currentVpc的1.0.0.0和/24分开
    getVpcs(region: any) {
        return new Promise(function (resolve, reject) {
            vpcApiRequest
                .DescribeVpcs({
                    Region: region
                })
                .done(function (data: any) {
                    // data = null
                    if (!data) {
                        data = {
                            vpcSet: []
                        };
                    }
                    var vpcList = data.vpcSet;
                    var currentVpc: any = {};
                    vpcList.unshift({
                        VpcName: Vue.$trans(`全部虚拟私有网络`),
                        VpcId: "all",
                        CidrBlock: "VPC"
                    });
                    if (!localStorage.vpcId) {
                        localStorage.vpcId = vpcList[0].VpcId;
                        currentVpc.vpcId = vpcList[0].VpcId;
                        currentVpc.vpcName =
                            vpcList[0].VpcName +
                            "(" +
                            vpcList[0].CidrBlock +
                            ")";
                    } else {
                        currentVpc.vpcId = localStorage.vpcId;
                        let hasIt = false;
                        _.forEach(vpcList, function (item) {
                            if (item.VpcId == currentVpc.vpcId) {
                                hasIt = true;
                                currentVpc.vpcName =
                                    item.VpcName + "(" + item.CidrBlock + ")";
                            }
                        });
                        if (!hasIt) {
                            localStorage.vpcId = vpcList[0].VpcId;
                            currentVpc.vpcId = vpcList[0].VpcId;
                            currentVpc.vpcName =
                                vpcList[0].VpcName +
                                "(" +
                                vpcList[0].CidrBlock +
                                ")";
                        }
                    }
                    resolve({
                        vpcList,
                        currentVpc
                    });
                });
        });
    },

    // 字段少，用于顶部下拉列表
    getVpcsOther(region: any) {
        return new Promise(function (resolve, reject) {
            vpcApiRequest
                .DescribeVpcInfos({
                    Region: region
                })
                .done(function (data: any) {
                    // data = null
                    if (!data) {
                        data = {
                            VpcSet: []
                        };
                    }
                    var vpcList = data.VpcSet;
                    var currentVpc: any = {};

                    vpcList.unshift({
                        VpcName: Vue.$trans(`全部虚拟私有网络`),
                        VpcId: "all",
                        CidrBlock: "VPC"
                    });
                    if (!localStorage.vpcId) {
                        localStorage.vpcId = vpcList[0].VpcId;
                        currentVpc.vpcId = vpcList[0].VpcId;
                        currentVpc.vpcName =
                            vpcList[0].VpcName +
                            "(" +
                            vpcList[0].CidrBlock +
                            ")";
                    } else {
                        currentVpc.vpcId = localStorage.vpcId;
                        let hasIt = false;
                        _.forEach(vpcList, function (item) {
                            if (item.VpcId == currentVpc.vpcId) {
                                hasIt = true;
                                currentVpc.vpcName =
                                    item.VpcName + "(" + item.CidrBlock + ")";
                            }
                        });
                        if (!hasIt) {
                            localStorage.vpcId = vpcList[0].VpcId;
                            currentVpc.vpcId = vpcList[0].VpcId;
                            currentVpc.vpcName =
                                vpcList[0].VpcName +
                                "(" +
                                vpcList[0].CidrBlock +
                                ")";
                        }
                    }
                    resolve({
                        vpcList,
                        currentVpc
                    });
                });
        });
    }
};
